// utils/theme.js - MODERN LIGHT DESIGN

export const T = {
  // ─── PRIMARY BACKGROUNDS ───
  bg: "#f8f9fa", // Light background
  surface: "#ffffff", // Card/panel background
  surfaceAlt: "#f6f8fa", // Alternative surface
  surfaceHover: "#f0f3f6", // Hover state

  // ─── ACCENTS ───
  orange: "#fb8500", // Primary action
  orangeLight: "rgba(251, 133, 0, 0.08)",
  orangeBorder: "rgba(251, 133, 0, 0.15)",

  green: "#1a7f37", // Success/Ready (darker for light mode)
  greenLight: "rgba(26, 127, 55, 0.08)",
  greenBorder: "rgba(26, 127, 55, 0.15)",

  red: "#da3633", // Urgent/Error (darker for light mode)
  redLight: "rgba(218, 54, 51, 0.08)",
  redBorder: "rgba(218, 54, 51, 0.15)",

  yellow: "#b08500", // In-progress (darker for light mode)
  yellowLight: "rgba(176, 133, 0, 0.08)",
  yellowBorder: "rgba(176, 133, 0, 0.15)",

  // ─── TEXT ───
  textPrimary: "#0d1117", // Primary text
  textSecond: "#424a53", // Secondary text
  textMuted: "#656d76", // Muted text (for timestamps, etc)
  textDisabled: "#8c959f", // Disabled text

  // ─── BORDERS ───
  border: "rgba(27, 31, 35, 0.06)", // Subtle border
  borderStrong: "rgba(27, 31, 35, 0.12)", // Stronger border
  borderLight: "rgba(27, 31, 35, 0.04)", // Very subtle

  // ─── SHADOWS ───
  shadowCard: "0 2px 8px rgba(0, 0, 0, 0.08)",
  shadowNew: "0 0 16px rgba(251, 133, 0, 0.12)",
  shadowReady: "0 0 16px rgba(26, 127, 55, 0.12)",
  shadowHover: "0 4px 16px rgba(0, 0, 0, 0.12)",

  // ─── STATUS COLORS ───
  success: "#1a7f37",
  warning: "#b08500",
  error: "#da3633",
  info: "#0969da",

  // ─── GRAYS (for neutral elements) ───
  gray50: "#f6f8fa",
  gray200: "#d0d7de",
  gray600: "#57606a",
  gray700: "#424a53",
  gray800: "#0d1117",
  gray900: "#000000",
};

// ─── MODERN DESIGN TOKENS ───
export const design = {
  // Spacing
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    xxl: "32px",
  },

  // Border radius
  radius: {
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    full: "9999px",
  },

  // Typography
  typography: {
    h1: { size: "32px", weight: 600, lineHeight: "1.2" },
    h2: { size: "24px", weight: 600, lineHeight: "1.3" },
    h3: { size: "18px", weight: 600, lineHeight: "1.4" },
    body: { size: "14px", weight: 400, lineHeight: "1.5" },
    bodySmall: { size: "12px", weight: 400, lineHeight: "1.5" },
    mono: { size: "12px", weight: 500, lineHeight: "1.4", fontFamily: "monospace" },
  },

  // Animations
  transitions: {
    fast: "150ms ease-out",
    normal: "250ms ease-out",
    slow: "400ms ease-out",
  },

  // Z-index
  zIndex: {
    base: 0,
    dropdown: 100,
    modal: 1000,
    toast: 2000,
  },
};

// ─── UTILITY STYLES (can be imported) ───
export const styles = `
  * {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', sans-serif;
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${T.surfaceAlt};
  }

  ::-webkit-scrollbar-thumb {
    background: ${T.borderStrong};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${T.textMuted};
  }

  /* Smooth transitions */
  * {
    transition: background-color ${design.transitions.fast}, 
                border-color ${design.transitions.fast},
                color ${design.transitions.fast};
  }
`;